import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import style from './style.less';

const DATE_FULL_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

class Datepicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    dateFormat: PropTypes.string,
    availableLabel: PropTypes.string,
    unavailableLabel: PropTypes.string,
    value: PropTypes.any,
    timeRange: PropTypes.array,
    closedDays: PropTypes.array,
    closedRange: PropTypes.array,
    shiftDate: PropTypes.number,
    dealerId: PropTypes.number,
    startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    isMechanic: PropTypes.bool,
  };

  static defaultProps = {
    dateFormat: DATE_FULL_TIME_FORMAT,
    availableLabel: 'Select',
    unavailableLabel: 'Closed',
    value: null,
    timeRange: [
      {
        label: 'AM',
        value: '00:00:00',
      },
      {
        label: 'PM',
        value: '12:00:00',
      },
    ],
    closedDays: [],
    closedRange: [],
    shiftDate: 1,
    startDate: moment().format(DATE_FULL_TIME_FORMAT),
    endDate: false,
    dealerId: 0,
  };
  static isSelected(oldValue, newValue) {
    if (oldValue === null) {
      return false;
    }

    return oldValue.format('x') === newValue.format('x');
  }

  constructor(props, context) {
    super(props, context);

    const now = moment();
    const { shiftDate } = props;
    const endOfWeek = now
      .clone()
      .add(shiftDate, 'days')
      .startOf('isoWeek')
      .add(7, 'days')
      .format('x');
    let page = 0;
    if (props.value && moment(props.value).format('x') > endOfWeek) {
      page = 1;
    }

    const value = props.value ? moment(props.value) : null;

    this.state = {
      now,
      page,
      value,
      header: [],
      body: [],
      dealerId: props.dealerId,
    };

    if (value) {
      this.props.onChange(value);
    }
  }

  componentDidMount() {
    // Todo: update this.state.now each hour and rerender component
    this.prepareAndSaveState();

    // Todo: remove listener on componentWillUnmount
    window.addEventListener('spBookingDeallerChanged', e => {
      this.setState({ dealerId: e.detail }, () => this.prepareAndSaveState());
    });
  }

  onChange = value => {
    this.props.onChange(value.format(this.props.dateFormat));
    this.prepareAndSaveState({ value });
  };

  changePage = value => {
    this.prepareAndSaveState({ page: this.state.page + value });
  };

  prepareAndSaveState(
    { page = this.state.page, value = this.state.value } = {},
  ) {
    const { shiftDate, timeRange } = this.props;
    const { now } = this.state;
    const beginDate = now
      .clone()
      .add(page * 7, 'days')
      .add(shiftDate, 'days')
      .startOf('isoWeek');
    const header = [];
    const body = [];

    for (let i = 0; i < 7; i++) {
      const date = beginDate.clone().add(i - shiftDate, 'days');
      header.push({
        day: date.format('ddd'),
        date: date.format('DD'),
        month: date.format('MMM'),
      });
    }

    timeRange.forEach(item => {
      const itemTime = moment(item.value, 'HH:mm:ss');
      const bodyData = {
        label: item.label,
        value: item.value,
      };
      const bodyItems = [];
      const timesToAssign = {
        hour: itemTime.hour(),
        minute: itemTime.minute(),
        second: itemTime.second(),
      };
      for (let i = 0; i < 7; i++) {
        const itemValue = beginDate
          .clone()
          .add(i - shiftDate, 'days')
          .set(timesToAssign);
        bodyItems.push({
          available: this.isAvailable(itemValue),
          selected: this.constructor.isSelected(value, itemValue),
          value: itemValue,
        });
      }
      bodyData.items = bodyItems;
      body.push(bodyData);
    });

    this.setState({
      header,
      body,
      page,
      value,
    });
  }

  isAvailable(date) {
    return true;
    // eslint-disable-next-line no-unreachable
    const { startDate, endDate, closedDays, closedRange } = this.props;
    const dateX = date.format('x');

    // Ingore validation
    if (this.props.dealerId !== this.state.dealerId) {
      return true;
    }

    if (closedDays.includes(date.day())) {
      return false;
    }

    if (
      !this.props.isMechanic &&
      startDate &&
      moment(startDate).format('x') > dateX
    ) {
      return false;
    }

    if (endDate && moment(endDate).format('x') < dateX) {
      return false;
    }

    for (let i = 0; i < closedRange.length; i++) {
      const rangeStart = moment(closedRange[i][0]).format('x');
      const rangeEnd = moment(closedRange[i][1]).format('x');
      if (rangeStart <= dateX && dateX <= rangeEnd) {
        return false;
      }
    }

    return true;
  }

  render() {
    const { header, body } = this.state;
    const { availableLabel, unavailableLabel } = this.props;

    return (
      <div className={style.calendar}>
        <div className={style.header}>
          <button className={style.back} onClick={() => this.changePage(-1)}>
            <i className={style.prevIcon} />
          </button>
          {header.map((item, i) => (
            <div key={i} className={style.th}>
              {item.day}
              <br />
              {item.date}
              <span className={style.thMonth}>{item.month}</span>
            </div>
          ))}
          <button className={style.next} onClick={() => this.changePage(1)}>
            <i className={style.nextIcon} />
          </button>
        </div>
        <div className={style.body}>
          {body.map((row, i) => (
            <div key={i} className={style.wrap}>
              <div className={style.label}>{row.label}</div>
              {row.items.map((item, j) => (
                <button
                  onClick={() => item.available && this.onChange(item.value)}
                  key={j}
                  className={
                    item.available
                      ? item.selected ? style.tdActive : style.td
                      : style.tdClosed
                  }
                >
                  {!item.selected ? (
                    item.available ? (
                      availableLabel
                    ) : (
                      unavailableLabel
                    )
                  ) : (
                    <i className={style.tick} />
                  )}
                </button>
              ))}
              <div className={style.emptyTd} />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Datepicker;
